import * as React from 'react';
import '../../styles/SplashPage.css';
import StandardLayout from '../layouts/StandardLayout';
import WarmLeadPopup from './admin/WarmLeadPopup';
import AddPropertyPopup from './admin/AddPropertyPopup';
import { userIsPropertyAdmin,userIsCompanyAdmin } from '../../utilities/identity';
import { getMyUser } from '../../api/User';

interface Props {
    text: string;
}

const SplashPage = (props: Props) => {
    const [showWarmLeadPopup, setShowWarmLeadPopup] = React.useState<boolean>(false);
    const [showAddPropertyPopup, setShowAddPropertyPopup] = React.useState<boolean>(false);
    const [warmLeadsStatus, setWarmLeadsStatus] = React.useState<boolean>(false);

    React.useEffect(() => {
      const fetchUserDetails = async () => {
          try {
              const response = await getMyUser();
              if (response && response.data) {
                  const status = response.data.warmLeadsStatus !== undefined ? response.data.warmLeadsStatus : true;
                  console.log('Fetched warmLeadsStatus:', status);   
                  setWarmLeadsStatus(status);
              } else {
                  console.log('No data, defaulting warmLeadsStatus to true');
                  setWarmLeadsStatus(true);  
              }
          } catch (error) {
              console.error('Error fetching user details:', error);
              setWarmLeadsStatus(true);   
          }
      };
  
      fetchUserDetails();
  }, []);
  
  


  React.useEffect(() => {
    const now = new Date();
    const weekOfMonth = Math.ceil(now.getDate() / 7);
    const isValidWeek = weekOfMonth === 2 || weekOfMonth === 4;

    console.log('isValidWeek:', isValidWeek);
    console.log('userIsPropertyAdmin:', userIsPropertyAdmin());
    console.log('userIsCompanyAdmin:', userIsCompanyAdmin());
    console.log('warmLeadsStatus:', warmLeadsStatus);

    if (isValidWeek && (userIsPropertyAdmin() || userIsCompanyAdmin()) && warmLeadsStatus) {
      setShowWarmLeadPopup(true);
    }
  }, [warmLeadsStatus]);

    const handleAddProperty = () => {
      setShowAddPropertyPopup(true);
    };
  
    const handleSubmitProperties = (properties: string, notes: string) => {
      console.log('Properties submitted:', properties);
      console.log('Notes:', notes);
    };
  
    const handleCloseWarmLeadPopup = () => {
      setShowWarmLeadPopup(false);
    };
  
    const handleCloseAddPropertyPopup = () => {
      setShowAddPropertyPopup(false);
    };
    return  <StandardLayout>
    <div className="content splash-page d-flex align-items-center justify-content-center flex-column">
        <h1>{props.text}</h1>

    </div>
    <>
                <WarmLeadPopup
                  isOpen={showWarmLeadPopup}
                  onClose={handleCloseWarmLeadPopup}
                  onAddProperties={handleAddProperty}
                />
                <AddPropertyPopup
                  isOpen={showAddPropertyPopup}
                  onClose={handleCloseAddPropertyPopup}
                  onSubmit={handleSubmitProperties}
                />
              </>
</StandardLayout>
}
  
export default SplashPage;



// WEBPACK FOOTER //
// ./src/components/pages/SplashPage.tsx